import { refundForexOrder as refundOnCore } from "service/moneeflo/legacy-forex-order-api";

export type RefundPayload = {
  /** In paise, as a string. */
  amountMinor: string;
  reason: string;
  reference: string;
};

export const refundForexOrder = async (data: RefundPayload): Promise<unknown> => {
  return await refundOnCore({ amountMinor: data.amountMinor, reason: data.reason, reference: data.reference });
};
